import * as React from "react"
const SvgPencilWrite = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m12.475 17.54 8.375-8.376-1.3-1.3-8.375 8.375zM3 15.99q0 .725.5 1.124t1.65.525a.9.9 0 0 1 .637.363q.239.313.213.712a1.04 1.04 0 0 1-.3.7.77.77 0 0 1-.675.225Q3 19.389 2 18.477q-1-.913-1-2.488 0-1.624 1.337-2.637 1.338-1.013 3.713-1.213.975-.075 1.463-.312.487-.239.487-.663 0-.55-.525-.862T5.75 9.814a.9.9 0 0 1-.638-.375.98.98 0 0 1-.187-.725 1.04 1.04 0 0 1 .35-.687.86.86 0 0 1 .7-.213q2.075.3 3.05 1.113T10 11.164q0 1.325-.963 2.075-.962.75-2.837.9-1.6.126-2.4.588T3 15.989Zm9.95 3.9-4.125-4.126 9.55-9.55q.5-.5 1.188-.5t1.187.5l1.75 1.75q.5.501.5 1.188t-.5 1.187l-9.55 9.55Zm-3.975.824q-.425.1-.75-.225-.325-.324-.225-.75l.825-3.975 4.125 4.125z" />
  </svg>
)
export default SvgPencilWrite
